export default "__VITE_ASSET__THmesYaI__"